import script from "./multi-factor-auth-contact-channels.vue?vue&type=script&setup=true&lang=ts"
export * from "./multi-factor-auth-contact-channels.vue?vue&type=script&setup=true&lang=ts"

import "./multi-factor-auth-contact-channels.vue?vue&type=style&index=0&id=b8507d44&lang=css"

const __exports__ = script;

export default __exports__